import axios from "axios";
import Cookies from "js-cookie";
import { clearSessionAndRedirect } from "../utils/auth.utils";

// Auth endpoints that should not trigger 401 redirect (to avoid loops on bad credentials)
const AUTH_ENDPOINTS = ["/rest-auth/login/", "/rest-auth/registration/", "/rest-auth/logout/"];

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    // Read CSRF token fresh on every request to handle token rotation
    const csrfToken = Cookies.get("csrftoken");
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized responses
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const isAuthEndpoint = AUTH_ENDPOINTS.some((endpoint) => requestUrl.includes(endpoint));

      // Only clear session and redirect for non-auth endpoints
      if (!isAuthEndpoint) {
        clearSessionAndRedirect();
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
